import { useEffect } from "react";
import { imageUploaderSelector } from "store/features/imageUploader/selectors/imageUploaderSelector";
import { ImageUpload } from "store/features/imageUploader/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { setImage, setUploadData } from "store/features/enlarge/actions";
import { getImageExtension } from "client/utils/getImageExtension";
import { reset } from "store/features/imageUploader/actions";
import { useRouter } from "next/router";
import translatedRoutedSlugs, { type TranslatedRouteSlugs } from "translatedRouteSlugs";

export const useEnlargeUploader = () => {
    const { images } = useAppSelector(imageUploaderSelector);
    const dispatch = useAppDispatch();
    const router = useRouter();

    function handleProceed(image: ImageUpload) {
        if (!image.file) {
            alert("Something went wrong. This should not happen.");
            return;
        }

        dispatch(
            setImage({
                createdAt: new Date(),
                format: getImageExtension(image.file.file),
                original: {
                    width: 0,
                    height: 0,
                    size: image.file.size ?? "0 KB",
                },
                preview: {
                    width: 0,
                    height: 0,
                    size: image.file.size ?? "0 KB",
                },
                src: image.file.src,
                title: image.file.file.name,
            }),
        );
        dispatch(setUploadData(image.upload));

        router.push(
            `/${
                translatedRoutedSlugs[`/image-enlarger/editor`]?.[
                    (router.locale as keyof TranslatedRouteSlugs["/image-enlarger/editor"]) ?? "en"
                ] ?? `image-enlarger/editor`
            }`,
        );
        dispatch(reset());
    }

    function deleteImage() {}
    function deleteAllImages() {}

    function checkImageStatus(images: ImageUpload[]) {
        const image = images[0];
        if (!image || image.fileState.status !== "added") return;
        handleProceed(image);
    }

    useEffect(() => {
        checkImageStatus(images);
    }, [images]);

    return { deleteImage, deleteAllImages };
};
